import React from 'react'
import * as EmailUtils from '@/checkout-instore-legacy/utils/EmailUtils'
import IdentificationInput from '@/checkout-instore-legacy/components/Identification/components/IdentificationInput'
import { getOrderForm } from '@/checkout-instore-legacy/utils/orderFormUtils'
import { injectIntl } from 'react-intl'
import { useLocalizationState } from '@vtexlab/assisted-sales-localization'

const clearEmail = (email) => EmailUtils.clearIfInStoreAnonymousEmail(email)

const UnifiedInput = injectIntl(
  ({ countryCode, getInitialValue, intl, ...rest }) => {
    const localizationState = useLocalizationState({
      countryCode,
    })

    // This workaround ignores document validation if it is a Passport already added to ClientProfileData
    // This identification screen will be discontinued and Passport validation is already done in the new identification flow
    // To reach this stage with the Passport in the clientProfile, there was validation before
    const isPassportOnOrderForm = (identificationText) => {
      const orderForm = getOrderForm()

      if (orderForm?.clientProfileData?.documentType !== 'passport') {
        return false
      }

      return orderForm?.clientProfileData?.document === identificationText
    }

    const isValidIdentification = (identificationText) => {
      if (isPassportOnOrderForm(identificationText)) return true

      const documentIsValid = localizationState.localizationConfig.input.document.validate(
        identificationText
      )

      if (documentIsValid) return true

      if (EmailUtils.validateEmail(identificationText)) return true

      return false
    }

    const getMask = (identificationText) => {
      if (
        localizationState.localizationConfig.input.document.validate(
          identificationText
        )
      ) {
        return localizationState.localizationConfig.input.document.format(
          identificationText
        )
      }

      if (EmailUtils.validateEmail(identificationText)) {
        return clearEmail(identificationText)
      }

      return identificationText
    }

    return (
      <IdentificationInput
        inputType="text"
        placeholder={intl.formatMessage({ id: 'identificationPlaceHolder' })}
        mask={getMask}
        initialValue={getInitialValue()}
        normalize={clearEmail}
        validate={isValidIdentification}
        errorMessage={intl.formatMessage({ id: 'errorInvalidIdentification' })}
        {...rest}
      />
    )
  }
)

export default UnifiedInput
